import { render, staticRenderFns } from "./CustomerCustomerRecurring.vue?vue&type=template&id=35ed3483&scoped=true"
import script from "./CustomerCustomerRecurring.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerRecurring.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerRecurring.vue?vue&type=style&index=0&id=35ed3483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed3483",
  null
  
)

export default component.exports